module.exports = __webpack_public_path__ + "static/media/thumb-down.938eac02.png";